const { wrapPage } = require('./gatsby-functions/pageWrap')

exports.wrapPageElement = wrapPage

exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  return location.state && location.state?.preventScroll ? false : true
}
